import * as React from 'react';
import * as _ from 'underscore';

import { Table, ITableOptions, ITableColumn } from '../../../../_common/platform/tsx/tableSelect/Table';
export { ITableOptions } from '../../../../_common/platform/tsx/tableSelect/Table';

interface ITableSelectProperties {
    options: ITableOptions;
    showFourthColumn?: boolean;
}

const tableColumns: ITableColumn[] = [
    {
        className: 'column-select',
        title: ''
    },
    {
        className: 'column-name',
        title: 'Name',
        sort: true
    },
    {
        className: 'column-path',
        title: 'Path',
        sort: true,
        orderFirst: true
    }
];

export function TableSelect(props: ITableSelectProperties) {
    const getRowClickHandlers = (key, onClick) => {
        return [onClick];
    };

    const getRowContent = (key) => {
        const obj = props.options.valuesHash[key];

        // For Resource Import:
        if (props.showFourthColumn) {
            return [obj['dirpath'].join('\\'), obj['fileGUID'], obj['inputFile'], obj['fileSize']];
        }

        // For Workspace Import
        return [obj['dirpath'].join('\\')];
    };

    const columns = [...tableColumns];

    // For Resource Import:
    if (props.showFourthColumn) {
        columns.push(
            {
                className: 'column-name',
                title: 'GUID',
                sort: false
            },
            {
                className: 'column-name',
                title: 'Resource Data File',
                sort: false
            },
            {
                className: 'column-name',
                title: 'Size',
                sort: false
            }
        );
    }

    return (
        <div className={'table-select-static table-select-list'}>
            <Table
                columns={columns}
                options={props.options}
                getRowClickHandlers={getRowClickHandlers}
                getRowContent={getRowContent}
            />
        </div>
    );
}
